module.exports = function() {
  return new Worker(__webpack_public_path__ + "83a98d959bf71af022c0.worker.js");
};